import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

import { LabelTag } from "@/modules/irohana-components/elements/LabelTag";
import { PageBack } from "@/modules/irohana-components/elements/PageBack";
import { TRequiredOne } from "@/modules/irohana-components/types/common";

export type TTopPageProps = {
  title: string;
  subTitle?: ReactNode;
  description?: string | ReactNode;
  rightContent?: ReactNode;
  isDraft?: boolean;
  tag?: ReactNode;
  titleAddon?: ReactNode;
  gap?: number;
  descriptionSx?: SxProps<Theme>;
} & TRequiredOne<{ backUrl: string; enablePageBack: boolean; onBack?: () => void }>;

export const TopPage: FC<TTopPageProps> = ({
  title,
  subTitle,
  description,
  backUrl,
  enablePageBack = true,
  onBack,
  rightContent,
  isDraft,
  tag,
  titleAddon,
  gap,
  descriptionSx,
}) => {
  return (
    <Stack gap={gap ?? "4px"}>
      {enablePageBack && <PageBack backUrl={backUrl} onBack={onBack} />}
      <Stack direction="row" gap={3} alignItems="center">
        <Stack gap={2} flex={1}>
          <Stack gap={2}>
            <Stack flexDirection="row" alignItems="center" gap={2}>
              <Typography variant="head20Bold">{title}</Typography>
              {isDraft && <LabelTag label="下書き" color="incomplete" />}
              {tag}
              {titleAddon}
            </Stack>
            {subTitle && <Typography variant="body14">{subTitle}</Typography>}
          </Stack>
          {typeof description === "string" ? (
            <Typography sx={{ whiteSpace: "pre-line", ...descriptionSx }} variant="body14" component="p">
              {description}
            </Typography>
          ) : (
            description
          )}
        </Stack>
        {rightContent}
      </Stack>
    </Stack>
  );
};
